import { UnderagePage } from '@resurs-internal/deposits-app-components';
import { useContext } from 'react';

import { CountryContext } from '@/contexts';

export const UnderageView = () => {
  const { country } = useContext(CountryContext);

  return <UnderagePage country={country} />;
};
